"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ldclientJs = require("ldclient-js");

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var devTooling = process.env.NODE_ENV === 'development' || process.env.REACT_APP_FFS_DEV_TOOLS_ACTIVE === 'true';

var extendClient = function extendClient(client) {
  var callbacks = [];
  var localStore = devTooling ? JSON.parse(_jsCookie.default.get('force_ffs') || '{}') || {} : {};
  var allFlagsOriginal = client.allFlags;
  return Object.assign(client, {
    onReady: new Promise(function (resolve) {
      client.on('ready', function () {
        return resolve(client);
      });
    }),
    getBoolean: function getBoolean(featureKey, defaultValue) {
      return client.onReady.then(function (c) {
        return c.variation(featureKey, defaultValue === true);
      });
    },
    onChange: function onChange(callback) {
      callbacks.push(callback);
    },
    change: function change(flags) {
      if (devTooling) {
        callbacks.forEach(function (c) {
          return c(flags);
        });
        Object.assign(localStore, flags);

        _jsCookie.default.set('force_ffs', JSON.stringify(localStore));
      }
    },
    reset: function reset(flag) {
      if (devTooling) {
        callbacks.forEach(function (c) {
          return c(_defineProperty({}, flag, allFlagsOriginal()[flag]));
        });
        (0, _lodash.unset)(localStore, flag);

        _jsCookie.default.set('force_ffs', JSON.stringify(localStore));
      }
    },
    resetAll: function resetAll() {
      if (devTooling) {
        callbacks.forEach(function (c) {
          return c(allFlagsOriginal());
        });
        Object.keys(localStore).forEach(function (k) {
          return (0, _lodash.unset)(localStore, k);
        });

        _jsCookie.default.set('force_ffs', JSON.stringify(localStore));
      }
    },
    allFlags: function allFlags() {
      return _objectSpread({}, allFlagsOriginal(), localStore);
    },
    isForced: function isForced(flag) {
      return localStore[flag] !== undefined;
    }
  });
};

var init = function init(apiKey, user, options) {
  return (0, _ldclientJs.initialize)(apiKey, user, options);
};

var featureFlagStore = {};

if (devTooling) {
  var initializeRef = init;
  var client;

  init = function init(apiKey, user, options) {
    console.log('Launchdarkly client initializing in development mode');
    client = initializeRef(apiKey, user, options);
    var originalVariation = client.variation;

    client.variation = function (key, defaultValue) {
      if (key in featureFlagStore) {
        console.log("Returning value for ".concat(key, " from local store: ").concat(featureFlagStore[key]));
        return featureFlagStore[key];
      }

      return originalVariation.call(_this, key, defaultValue);
    };

    return client;
  };

  var root = document.createElement('div');

  if (document && document.body) {
    document.body.appendChild(root);
  }

  var open = false;

  var renderWindow = function renderWindow() {
    open = true;

    _reactDom.default.render(_react.default.createElement(Overlay, null), root);
  };

  var removeWindow = function removeWindow() {
    _reactDom.default.unmountComponentAtNode(root);

    open = false;
  };

  var change = function change(flag, value) {
    console.log('changing', flag, 'to', value);
    client.change(_defineProperty({}, flag, value));
  };

  var FlagEntry = function FlagEntry(_ref) {
    var flagKey = _ref.flagKey,
        flagValue = _ref.flagValue,
        forcedIn = _ref.forcedIn;

    var _useState = (0, _react.useState)(flagValue),
        _useState2 = _slicedToArray(_useState, 2),
        val = _useState2[0],
        setVal = _useState2[1];

    var _useState3 = (0, _react.useState)(forcedIn),
        _useState4 = _slicedToArray(_useState3, 2),
        forced = _useState4[0],
        setForced = _useState4[1];

    var onToggle = function onToggle() {
      setVal(!val);
      change(flagKey, !val);
      setForced(true);
    };

    var onReset = function onReset() {
      setVal(flagValue);
      change(flagKey, flagValue);
      setForced(false);
      client.reset(flagKey);
    };

    return _react.default.createElement("div", {
      style: {
        margin: '4px 0'
      }
    }, _react.default.createElement("span", {
      style: {
        width: '60px',
        display: 'inline-block'
      }
    }, flagValue === true ? _react.default.createElement("span", null, _react.default.createElement("button", {
      onClick: onToggle
    }, "Turn off")) : _react.default.createElement("span", null, _react.default.createElement("button", {
      onClick: onToggle
    }, "Turn on"))), _react.default.createElement("span", {
      style: {
        width: '30px',
        display: 'inline-block',
        color: val === true ? 'darkgreen' : 'darkred',
        fontWeight: val === true ? 'bold' : 'normal'
      }
    }, val === true ? 'On' : 'Off'), _react.default.createElement("span", null, flagKey), forced && _react.default.createElement("div", {
      style: {
        float: 'right'
      }
    }, _react.default.createElement("span", {
      style: {
        display: 'inline-block',
        margin: '0 2px',
        color: 'darkmagenta',
        fontWeight: '500',
        fontSize: 'small'
      }
    }, "Forced locally"), _react.default.createElement("button", {
      onClick: onReset
    }, "reset")));
  };

  var resetAll = function resetAll() {
    client.resetAll();
    removeWindow();
    renderWindow();
  };

  var SearchBox = function SearchBox(_ref2) {
    var filter = _ref2.filter,
        onFilter = _ref2.onFilter;
    return _react.default.createElement("div", {
      style: {
        margin: '4px 0'
      }
    }, _react.default.createElement("input", {
      style: {
        padding: '2px 4px'
      },
      type: "text",
      placeholder: "Filter",
      value: filter,
      onChange: function onChange(e) {
        return onFilter(e.target.value);
      },
      autoFocus: true
    }), _react.default.createElement("button", {
      onClick: resetAll,
      style: {
        float: 'right'
      }
    }, "Reset all"));
  };

  var Modal = function Modal() {
    var filter = localStorage.getItem('__ldwrapper.filter');

    var _useState5 = (0, _react.useState)(null),
        _useState6 = _slicedToArray(_useState5, 2),
        filterState = _useState6[0],
        setFilterState = _useState6[1];

    var setFilter = function setFilter(f) {
      localStorage.setItem('__ldwrapper.filter', f);
      setFilterState(f);
    };

    var style = {
      backgroundColor: '#fefefe',
      border: '1px solid #888',
      fontSize: '16px',
      position: 'absolute',
      padding: '16px',
      top: '10vh',
      left: '33vw',
      width: '34vw',
      height: '80vh',
      overflowY: 'scroll'
    };
    var flags = client.allFlags();
    var flagKeys = (filter && filter.length > 0 ? Object.keys(flags).filter(function (f) {
      return f.indexOf(filter) !== -1;
    }) : Object.keys(flags)).filter(function (f) {
      return typeof flags[f] === 'boolean';
    });
    return _react.default.createElement("div", {
      style: style,
      role: "dialog",
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, _react.default.createElement("h3", null, "Feature flags"), _react.default.createElement(SearchBox, {
      onFilter: setFilter,
      filter: filter
    }), _react.default.createElement("div", null, flagKeys.map(function (key) {
      return _react.default.createElement(FlagEntry, {
        key: key,
        flagKey: key,
        flagValue: flags[key],
        forcedIn: client.isForced(key)
      });
    })));
  };

  var Overlay = function Overlay() {
    var style = {
      position: 'fixed',
      zIndex: 1,
      left: 0,
      top: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.4)'
    };
    return _react.default.createElement("div", {
      style: style,
      onClick: removeWindow
    }, _react.default.createElement(Modal, null));
  };

  var lastF = 0;
  document.addEventListener('keyup', function (event) {
    var key = event.key || event.keyCode;

    if (key === 'f') {
      var now = new Date().getTime();

      if (lastF + 200 > now) {
        // callbacks.forEach(c => c({
        //   myFlag: true,
        // }));
        renderWindow();
      }

      lastF = now;
    } else if (key === 'Escape' && open) {
      removeWindow();
    } else {
      lastF = 0;
    }
  });
}

var buildClient = function buildClient(apiKey, user, options) {
  return extendClient(init(apiKey, user, options));
};

var _default = buildClient;
exports.default = _default;